import { EOSTabItem } from '../store/types/Layout.types';

export const EOS_APPLICATION_NAME = 'Energy Operations System';
export const EOS_APPLICATION_SUBTITLE = 'Shell Energy';

export const EOS_MENU_TABS: EOSTabItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    route: '/eos/dashboard',
  },
  {
    key: 'scenario-analysis',
    label: 'Scenario Analysis',
    route: '/eos/scenario-analysis',
  },
  {
    key: 'forecast',
    label: 'Forecast',
    route: '/eos/forecast',
  },
  {
    key: 'audit',
    label: 'Audit',
    route: '/eos/audit',
  },
];

export const EOS_ERROR_MESSAGES = {
  SYSTEM_HEALTH_ERROR: 'Unable to fetch EOS system health status',
  NOTIFICATION_FETCH_ERROR: 'Failed to fetch notifications',
  NAVIGATION_ERROR: 'Navigation failed',
} as const;
